import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// 회원사 업무문의
class MemberCompanyInquiryApi extends Requestor {
    /**
     * 리스트 조회
    */
    getItemList(params = {}) {
        return this.get({
            url: '/api/v2/partner-inquiries',
            params,
        });
    }
    /**
     * 단건 조회
    */
    getItem(id, params) {
        return this.get({
            url: `/api/v2/partner-inquiries/${id}`,
            params,
        });
    }
    /**
     * 템플릿 조회
     */
    getTempList() {
        return this.get({
            url: '/api/v2/partner-inquiries/templates',
        });
    }
    /**
     * 단건 등록
     */
    postItem(data) {
        console.log('등록', data);
        return this.post({
            url: '/api/v2/partner-inquiries',
            data,
        });
    }
    /**
     * 단건 삭제
     */
    deleteItem(id) {
        return this.delete({
            url: `/api/v2/partner-inquiries/${id}`,
        });
    }
    /**
     * 단건 수정
     */
    putItem(id, data) {
        return this.put({
            url: `/api/v2/partner-inquiries/${id}`,
            data,
        });
    }
}
export const memberCompanyInquiryApi = new MemberCompanyInquiryApi(clientInstance);
